/** The graph's nodes, in the order they run — one `updates` event arrives per node. */
export const AGENT_STEPS = [
    "validate_topic",
    "normalize_topic",
    "discover_domains",
    "verify_traffic",
    "drop_irrelevant",
    "classify_domains",
    "create_segments",
    "publish_assets",
    "warm_overview",
] as const;

/** `rejected`: the agent finished without an industry and named why (`errorCode`), so the
 *  user rephrases the prompt instead of retrying or collecting the same run. */
export type CustomIndustryAgentState = "idle" | "generating" | "done" | "error" | "rejected";

export type CreatedIndustry = {
    industryId: string;
    industryName: string;
};

export type ClassifiedDomain = {
    domain: string;
    reason: string;
    avgMonthlyVisits: number;
};
